import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import api from './utils/api';

Vue.config.productionTip = false
Vue.prototype.$api = api;

Vue.use(ElementUI);

let hostname = location.hostname;
if (hostname == "pack.felixtech.cn") {
  window.request_host = "https://packapi.felixtech.cn";
} else {
  window.request_host = "https://packapi.felixtech.cn";
  // window.request_host = "http://127.0.0.1:10808";
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
